// ExerciseCard.js
import React, { useState } from "react";
import { useSwipeable } from "react-swipeable";
import { Link } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";

const ExerciseSwipable = ({ doc, handleDelete }) => {
  const [showDelete, setShowDelete] = useState(false);
  const swipeHandlers = useSwipeable({
    onSwipedLeft: () => setShowDelete(true),
    onSwipedRight: () => setShowDelete(false),
    preventDefaultTouchmoveEvent: true,
  });

  return (
    <div
      key={doc.name}
      className="relative"
      onMouseLeave={() => setShowDelete(false)}
    >
      <div {...swipeHandlers} className="exercise-card">
        <Link to={`/exerciseBasic/${doc.name}`} state={{ doc }}>
          <div className="exercise-card-list-item exercise-gradient">
            <strong className="text-xl">{doc.name}</strong>
          </div>
        </Link>
      </div>

      {/* Conditionally Render Delete Button */}
      {showDelete && (
        <div
          className={`absolute h-7/8 flex justify-center top-1 right-2 bg-red-500 text-white rounded-r-xl ${showDelete ? "visible" : "invisible"}`}
          style={{ zIndex: 10, boxShadow: 2 }}
        >
          <button
            className='bg-transparent'
            onClick={() => handleDelete(doc.name)}>
            <FaTrashAlt className='text-2xl'></FaTrashAlt>
          </button>
        </div>
      )}
    </div>
  );
};

export default ExerciseSwipable;
